<template>
  <div class="lodgingExperience">
    <BannerSwiper :bannerData="bannerList" />
    <div class="rural-info">
      <div class="article-content">
        <div class="article">
          <div class="article-title">
            {{ lan ? "HeChunZhu" : "和春住" }}
          </div>
          <div class="article-subtitle">
            {{
              lan
                ? "A Lingnan-style guesthouse nestled in a 700-year-old ancient village"
                : "隐落在700年古村的岭南民宿"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? `"If you happen to be in Jiangnan during spring, do stay with spring." The name "HeChunZhu", which literally translates as "staying with spring", is inspired by the Song Dynasty poet Wang Guan's verse in his poem titled Busuanzi: Sending Bao Haoran to the East of Zhejiang. While inviting guests from all over the world to taste the characteristic charm of Lingnan, "HeChunZhu" is committed to creating a beautiful life of harmony between humanity and nature.`
                : "和春住文化乡墅是塱头项目的重要业态，它以实地验证的方式，展现出了一种对古村生态创新性保护和继承的积极姿态：二十一座独栋乡居院落全部改建自古村旧屋，在充分调研当地建筑特色和居民生活实景基础上，采用了当代原生态设计，使和春住巧妙融入了塱头古村的建筑群中，成为了其“梳式格局”的延展部分；在民宿内部又借助三间两廊的布局，传达出岭南传统民居的独特韵味，为追求品质又热爱文化的现代人营造出一种乡野闲居的新生活。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? `HeChunZhu demonstrates an active approach to the innovative protection and inheritance of the ancient village ecosystem. Its twenty-one detached rural residences have all been renovated from old village houses. Based on thorough research of local architectural features and real-life scenarios, contemporary ecological design has been employed to integrate HeChunZhu subtly into the architectural ensemble of Langtou Ancient Village, making it an extension of the building complex's "comb-pattern" layout. The three-room and two-wing layout encapsulates the distinctive charm of traditional Lingnan residences, defining a new lifestyle of rural leisure for modern people who value quality and culture.`
                : "公益是塱头项目始终秉持的根本原则。“和春住”范围内所有古建翻新、维护和新建项目均由唯品会公益捐建，项目全部收入留在本地，助力乡村振兴事业可持续发展。同时，项目驻地运营岗位面向本地村民开放，希望让更多塱头村民深入地参与到塱头乡村振兴项目中，成为古村活化的关键一环。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? "HeChunZhu is not merely a boutique guesthouse; it also serves various functions such as museological learning, leisure and entertainment, business hospitality, and dining. The public areas are fitted with distinctive facilities, and the courtyards encompass bedrooms, living rooms, bathrooms, tea rooms, and courtyards among other functional areas, each distinctive yet harmoniously integrated."
                : "秩序井然的空间格局之中，更有书香墨韵萦绕的鲜活生活。塱头自古尊师重教、诗礼传家、崇尚读书，具有浓郁的耕读传家文化特色。明清之际，塱头多人高中科举，科甲人才辈出。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? `Inspirations for a beautiful life are found not only in scenic vistas but also in the clever nuances of the overall design. In HeChunZhu, Courtyard One is called "Dong (East)", Courtyard Two "Xiao (Hermitage)", Courtyard Three "Jiang (River)"... each named after a rhyme category used in traditional calendaring. Each rhyme category is then used to present a welcoming poem exclusive to guests of the respective courtyard. Amid these rhymes and the poetry, shines the brilliant Chinese culture and the enchanting days.`
                : "和春住，不必到江南。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "向阳生，唯有在塱头。"
            }}
          </div>
          <div class="article-subtitle">
            {{
              lan
                ? ""
                : "命名来源与文化内涵"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "“若到江南赶上春，千万和春住。”“和春住”的命名来源于宋代王观的词《卜算子·送鲍浩然之浙东》。在邀请天南地北的住客赏味岭南地域风情的同时，“和春住”也致力于传递一种人与自然和谐共处的美好生活。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "中国古代的韵书按韵归字，同一韵部的字举一字为标目，叫作韵目。如读ong韵的字以“东”为韵目。晚清通电报之初，因为发送电报按字论价，为节约用字，发明了一种新的纪日法——从古人耳熟能详的“平水韵”“佩文韵”中挑选出三十个韵目，分别代表三十天，这就诞生了“韵目代日”纪日法。如“马”是21日的代称，因此，1927年5月21日的“湖南事变”又称“马日事变”。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "和春住沿用韵目代日为院落取名，一号院名“东”、二号院名“萧”、三号院名“江”……同时，又以该韵部为韵脚，为住客您献上专属的迎客诗。韵目之中、诗词背后，是灿烂的中国文化，及一个个富有韵致的日子。"
            }}
          </div>
          <div class="article-subtitle">
            {{
              lan
                ? ""
                : "院落特色"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "和春住的二十一座独栋乡居院落，全部改建于塱头古村传统民居，保留三间两廊、天井、围合庭院等传统格局，营造出一方静谧的桃花源。空间设计包含了卧室、客厅、洗浴间、茶室、庭院等多种功能区域，各具特色，却又和谐统一。这种巧妙的安排，既保留了古朴的岭南建筑魅力，又满足了现代人对于私密空间的需求。"
            }}
          </div>
          <div class="article-info" v-if="lan"></div>
          <div class="article-info" v-if="!lan">
            院落内，和春住为住客呈现了一场不可多得的文化休闲之旅：<br />
            -
            独特的典藏展柜及介绍折页，百年前的古籍、信札等珍稀藏品在这里触手可及
            <br />
            - 24小时专属管家，提供定制化服务解决实际出行中的每个问题 <br />
            - 以塱头古村乡野之趣为灵感定制的入住伴手礼 <br />-
            专属下午茶、晚安羹和欢迎小食
          </div>
          <div class="article-subtitle">
            {{
              lan
                ? ""
                : "公共空间"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "和春住不仅仅是一座精品民宿，还兼具博物学习、休闲娱乐、商务会客、餐饮服务等多项功能。在公共区域，配套建设有多个特色功能空间："
            }}
          </div>
          <div class="article-info">
            {{ lan ? "" : "“和春嬉”是兼具中西方设计之美的泳池；" }}
          </div>
          <div class="article-info">
            {{ lan ? "" : "“和春坐”是乡野之风与茗香环绕的茶室；" }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "“和春宴”是以创意烹饪将花都特色食材化为人间珍馐的餐厅；"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "“和春言”是既具会务功能又藏有近百种塱头老家具的小型博物馆；"
            }}
          </div>
          <div class="article-info">
            {{ lan ? "" : "“和春览”是探寻“和春住”前世今生的展厅；" }}
          </div>
          <div class="article-info">
            {{ lan ? "" : "“和春野”是鲜花绿植缤纷满目的花房。" }}
          </div>
          <div class="article-info">
            {{
              lan
                ? ""
                : "正如春雨润物无声，和春住为每一个独特的灵魂打造独一无二的专属体验，助人收拾身心，复得返自然。"
            }}
          </div>
        </div>
        <div class="rural-img">
          <img class="rural-img-show" src="@/assets/HCZ1.jpg" alt="" />
          <img class="rural-img-show" src="@/assets/HCZ2.jpg" alt="" />
          <img class="rural-img-show" src="@/assets/HCZ3.jpg" alt="" />
          <img class="rural-img-show" src="@/assets/HCZ4.jpg" alt="" />
        </div>
      </div>
      <div class="share-box" v-if="!isIndex">
        <ShareQr :showApplet="false" :showExhibitionInfo="false" :showPublic="false"  />
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import ShareQr from "../components/shareQr.vue";
import BannerSwiper from "../components/bannerSwiper.vue";

export default {
  name: "lodgingExperience",
  components: {
    ShareQr,
    BannerSwiper,
  },
  data() {
    return {
      isIndex: false,
      content: "",
      pageIndex: 1,
      bannerList: [],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    async init() {
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "rural_experience_banner" },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            if (data && data.length > 0) {
              // 修复banner数据处理逻辑，确保数据格式正确
              const processedBannerList = data.map((el, index) => {
                let imgSrc = "";
                
                // 处理image字段，可能是字符串也可能是对象
                if (el.image) {
                  try {
                    const imageData = typeof el.image === 'string' ? JSON.parse(el.image) : el.image;
                    if (Array.isArray(imageData) && imageData.length > 0 && imageData[0].src) {
                      imgSrc = imageData[0].src;
                    }
                  } catch (e) {
                    console.error("解析image数据失败:", e);
                    // 如果解析失败，直接使用image字段作为图片路径
                    imgSrc = el.image;
                  }
                }
                
                return {
                  id: el.id || index,
                  img: imgSrc,
                  video: el.video || "" // 如果有视频字段也一并传递
                };
              });
              
              this.bannerList = processedBannerList;
            }
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.lodgingExperience {
  margin-top: 94px;
}
.rural-info {
  position: relative;
  width: 1440px;
  height: 100%;
  margin: 70px auto;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 1060px;
}
.article-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.article-subtitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.detail-sub-title {
  margin-bottom: 32px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: 700;
}
.article-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: 400;
  margin-bottom: 30px;
}
.share-box {
  position: absolute;
  right: 0px;
  top: 95px;
}
.rural-img {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 100px;
}
.rural-img-show {
  width: 708px;
  height: 354px;
  margin-bottom: 26px;
}
@media (max-width: 1440px) {
  .lodgingExperience {
    margin-top: 80px;
    overflow: hidden;
  }

  .rural-info {
    position: relative;
    width: 98%;
    height: 100%;
    margin: 0px auto 80px;
    background-color: #fff;
  }
  .article-content {
    width: 80%;
    margin-left: 20px;
  }
  .article {
    width: 92%;
    margin: 50px auto;
  }
  .article-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-top: 20px;
  }
  .article-subtitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 10px 0;
  }
  .article-info {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 32px;
    font-weight: Regular;
    margin-bottom: 10px;
  }
  .share-box {
    position: absolute;
    right: 20px;
    top: 95px;
  }
  .rural-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 0px;
  }
  .rural-img-show {
    width: 49%;
    height: auto;
    margin: 10px auto;
    object-fit: contain;
  }
  .grey-line {
    width: 92%;
    margin: 70px auto 0;
    height: 1px;
    background: #d8d8d8;
  }
}
@media (max-width: 960px) {
  .lodgingExperience {
    margin-top: 80px;
  }

  .rural-info {
    position: relative;
    width: 98%;
    height: 100%;
    margin: 0px auto 50px;
    background-color: #fff;
  }
  .article-content {
    width: 98%;
    margin: 0 auto;
  }
  .article {
    width: 92%;
    margin: 30px auto;
  }
  .article-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 24px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-top: 20px;
  }
  .detail-sub-title {
    margin: 22px 0 10px;
    font-family: SourceHanSansCN-Bold;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 700;
  }
  .article-subtitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 10px 0;
  }
  .article-info {
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    font-weight: Regular;
    margin-bottom: 10px;
  }
  .share-box {
    position: absolute;
    right: 0px;
    top: 95px;
  }
  .rural-img {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 0px;
  }
  .rural-img-show {
    width: 90%;
    height: auto;
    margin: 5px auto;
    object-fit: contain;
  }
  .grey-line {
    width: 92%;
    margin: 70px auto 0;
    height: 1px;
    background: #d8d8d8;
  }
}
</style>